type Env = Window['env'];

const getMercuryEnv = <K extends keyof Env>(variable: K): Env[K] => {
  if (typeof window === 'undefined' || !window.env) {
    return '' as Env[K];
  }

  return window.env[variable] ?? ('' as Env[K]);
};

export const MERCURY_URL = getMercuryEnv('REACT_APP_MERCURY_URL');
export const MERCURY_ENV = getMercuryEnv('REACT_APP_MERCURY_ENVIRONMENT');
export const BLUEMINE_BASE_URL = getMercuryEnv('REACT_APP_MERCURY_BLUEMINE_BASE_URL');
export const DISPLAY_ENV_WARNING = getMercuryEnv('REACT_APP_MERCURY_DISPLAY_ENV_WARNING');
export const SENTRY_DSN = getMercuryEnv('REACT_APP_SENTRY_DSN');
export const AI_AGENT_KARLA_ENDPOINT_URL = getMercuryEnv(
  'REACT_APP_MERCURY_AI_AGENT_KARLA_ENDPOINT_URL'
);
export const POSTHOG_HOST = getMercuryEnv('REACT_APP_POSTHOG_HOST');
export const POSTHOG_KEY = getMercuryEnv('REACT_APP_POSTHOG_KEY');
